import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';
import { IOverallStatisticsParam, IOverallStatisticsItem } from '@core/main/types';

const hostUrl = getHostbaseUrl();

/**
 * 接口用量 - 整体统计 - 获取分页列表
 * @param isAgent - 是否是代理商
 */
export async function queryOverallStatisticsPage(params: IOverallStatisticsParam, isAgent: boolean) {
  let total = 0;
  let data = [] as IOverallStatisticsItem[];

  try {
    const { code, context, message } = await Http.post<{ data: IOverallStatisticsItem[]; total: number }>(
      `${hostUrl}/report/infra-api/${isAgent ? 'agent' : 'company'}-total/page`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || {} as { data: IOverallStatisticsItem[]; total: number };

      data = res.data || [];
      total = res.total || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 接口用量 - 整体统计 - 导出
 * @param isAgent - 是否是代理商
 */
export async function exportOverallStatistics(params: IOverallStatisticsParam, isAgent: boolean) {
  let buffer = null as Blob | null;
  let fileName = '';

  try {
    const { code, context, headers, message } = await Http.post<Blob>(
      `${hostUrl}/report/infra-api/${isAgent ? 'agent' : 'company'}-total/export`,
      params,
      { responseType: 'blob' },
    );

    if (headers['content-disposition']) {
      const match = headers['content-disposition'].match(/filename=(.+);?/);

      if (match && match[1]) {
        fileName = decodeURIComponent(match[1].trim().replace(/"/g, ''));
      }
    }

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    buffer,
    fileName, 
  };
}

